import React, { useState, useEffect } from 'react';
import { updateConsentMode, triggerConsentEvent } from 'utils/consentUtils';
import { CookiesConsentType } from 'types/CookiesConsentType';
import { CookieConsentContext } from './CookieConsentContext';
import Cookies from 'js-cookie';

export const CookieConsentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [cookieBannerChecked, toggleCookieBannerChecked] =
    useState<boolean>(false);
  const [cookiesConsent, setCookiesConsent] = useState<CookiesConsentType>({
    essential: true,
    functional: false,
    analytics: false,
    marketing: false,
    social: false,
  });

  useEffect(() => {
    const storedConsent = Cookies.get('cookieConsent');
    if (storedConsent) {
      try {
        const parsedConsent = JSON.parse(storedConsent);
        setCookiesConsent(parsedConsent);
        updateConsentMode(parsedConsent);
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (cookieBannerChecked) {
      Cookies.set('cookieConsent', JSON.stringify(cookiesConsent), {
        expires: 365,
      });
      updateConsentMode(cookiesConsent);
      triggerConsentEvent();
    }
  }, [cookiesConsent, cookieBannerChecked]);

  return (
    <CookieConsentContext.Provider
      value={{
        cookiesConsent,
        setCookiesConsent,
        cookieBannerChecked,
        toggleCookieBannerChecked,
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};
